module.exports = __webpack_public_path__ + "static/media/LogoFooter.64fd76d4.png";